export const palette = {
  primary: {
    extraLight: '#E7EEF4',
    light: '#9AC4E1',
    main: '#1571C1',
    dark: '#024B7F',
    extraDark: '#012B48',
  },
  secondary: {
    light: '#FFFFFF',
    main: '#FFFFFF',
    dark: '#ECEEF0',
  },
  success: {
    extraLight: '#D8E5DE',
    light: '#B1CBBD',
    main: '#3B7D5B',
    dark: '#295840',
  },
  danger: {
    extraLight: '#F0CDD4',
    light: '#DA8393',
    main: '#B40726',
    dark: '#7E051B',
  },
  gray: {
    extraLight: '#D9DEE1',
    light: '#BDC5CA',
    main: '#A1ACB3',
    dark: '#687082',
  },
  black: {
    light: '#212A31',
    main: '#091823',
    dark: '#020B11',
  },
  white: {
    main: '#FFFFFF',
    dark: '#ECEEF0',
  },
};
